import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

// What needs doing in a folder, a person, a truck: one quiet line that only
// appears when something does. Expired and missing are red — chase them
// now; expiring is amber — chase them soon.

export interface Attention { missing: number; expiring: number; expired: number }

export const attentionTotal = (a?: Attention | null) => (a ? a.missing + a.expiring + a.expired : 0);
/** What must be chased now: run out, or never filed. */
export const attentionUrgent = (a?: Attention | null) => (a ? a.missing + a.expired : 0);

/** "1 expired · 2 missing · 1 expiring", worst first, or '' when all is well. */
export function describeAttention(a?: Attention | null): string {
  if (!a) return '';
  return [
    a.expired && `${a.expired} expired`,
    a.missing && `${a.missing} missing`,
    a.expiring && `${a.expiring} expiring`,
  ].filter(Boolean).join(' · ');
}

const AttentionLine: React.FC<{ attention?: Attention | null }> = ({ attention }) => {
  const text = describeAttention(attention);
  if (!text) return null;
  const urgent = attentionUrgent(attention) > 0;
  return (
    <Stack direction="row" alignItems="center" gap={0.75} sx={{ minWidth: 0 }}>
      <Box sx={{ width: 7, height: 7, borderRadius: '50%', flexShrink: 0, bgcolor: urgent ? 'error.main' : 'warning.main' }} />
      <Typography variant="caption" noWrap sx={{ color: urgent ? 'error.main' : 'warning.dark', fontWeight: 600 }}>
        {text}
      </Typography>
    </Stack>
  );
};

export default AttentionLine;
